import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

export const StyledListItemLoaderWrapper = styled.div`
    display: flex;
    width: 100%;
`;

export const StyledListItemSimpleLoader = styled(Flex)`
    align-items: center;
    justify-content: flex-start;
    height: 48px;
    padding-left: 8px;
    border-radius: 8px;
    border: 1px solid ${colorsPalettes.carbon[50]};
    width: 100%;
`;

export const StyledListItemDescriptionLoader = styled(Stack)`
    height: 32px;
    gap: 4px;
`;
